import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';
import { FiSearch, FiSettings, FiUpload } from 'react-icons/fi';

const ADMIN_ID = '5ca0e6e1-8cdb-4a6f-89bd-c1846feab27b';

export default function Header({ onOpenUpload }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isAdmin, setIsAdmin] = useState(false);
  
  const [searchQuery, setSearchQuery] = useState(searchParams.get('q') || '');

  useEffect(() => {
    setSearchQuery(searchParams.get('q') || '');
  }, [searchParams]);

  useEffect(() => {
    const checkAdmin = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setIsAdmin(session?.user?.id === ADMIN_ID);
    };
    checkAdmin();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAdmin(session?.user?.id === ADMIN_ID);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchQuery(val);
    
    if (location.pathname === '/') {
      if (val) {
        searchParams.set('q', val);
        setSearchParams(searchParams);
      } else {
        searchParams.delete('q');
        setSearchParams(searchParams);
      }
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate(`/?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-retro-lime px-4 py-3 flex items-center gap-4 w-full border-b-4 border-retro-brown">
      <Link to="/" className="flex items-center justify-center hover:scale-105 transition-transform text-retro-brown">
        <span className="font-display text-3xl tracking-wider">YOOPOST</span>
      </Link>

      <form 
        onSubmit={handleSearchSubmit}
        className="flex-1 flex items-center bg-retro-cream border-2 border-retro-brown shadow-retro-sm rounded-full px-4 py-2 mt-1 mb-1 focus-within:shadow-retro transition-shadow mx-4 max-w-xl"
      >
        <SafeIcon icon={FiSearch} className="text-retro-brown text-xl mr-2 font-bold flex-shrink-0" />
        <input 
          type="text" 
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search graphics, tags..." 
          className="bg-transparent border-none outline-none w-full text-[16px] font-medium placeholder-retro-brown/50 text-retro-brown"
        />
      </form>

      <div className="flex items-center gap-3 ml-auto">
        <button 
          onClick={onOpenUpload}
          className="px-5 py-2.5 bg-retro-blue text-white rounded-full font-bold text-[15px] border-2 border-retro-brown shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 active:translate-y-1 active:shadow-retro-active transition-all flex items-center gap-2 uppercase tracking-wide"
        >
          <SafeIcon icon={FiUpload} className="text-lg" /> Upload Flyer
        </button>

        {isAdmin ? (
          <Link to="/admin" className="px-5 py-2.5 bg-retro-yellow text-retro-brown rounded-full font-bold text-[15px] border-2 border-retro-brown shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 active:translate-y-1 active:shadow-retro-active transition-all flex items-center gap-2 uppercase tracking-wide hidden sm:flex">
            <SafeIcon icon={FiSettings} className="text-lg" /> Admin
          </Link>
        ) : (
          <Link to="/login" className="px-4 py-2 bg-retro-cream text-retro-brown rounded-full font-bold text-[13px] border-2 border-retro-brown shadow-retro-sm hover:shadow-retro hover:-translate-y-0.5 active:translate-y-1 active:shadow-retro-active transition-all hidden sm:block">
            Admin Login
          </Link>
        )}
      </div>
    </header>
  );
}